export const allFilters = [
    {
        title: "Sets",
        allselected: true,
        singleSelection: false,
        items: [
            {
                name: "1",
                selected: true,
                amount: 0
            },
            {
                name: "2",
                selected: true,
                amount: 0
            },
            {
                name: "3",
                selected: true,
                amount: 0
            },
            {
                name: "4",
                selected: true,
                amount: 0
            },
            {
                name: "5",
                selected: true,
                amount: 0
            },
        ],
    },
    {
        title: "Rotations",
        allselected: true,
        singleSelection: false,
        items: [
            {
                name: "1",
                selected: true,
                amount: 0
            },
            {
                name: "2",
                selected: true,
                amount: 0
            },
            {
                name: "3",
                selected: true,
                amount: 0
            },
            {
                name: "4",
                selected: true,
                amount: 0
            },
            {
                name: "5",
                selected: true,
                amount: 0
            },
            {
                name: "6",
                selected: true,
                amount: 0
            },
        ],
    },
    {
        title: "Attack Combos",
        allselected: true,
        singleSelection: false,
    },
    {
        title: "Stages",
        allselected: true,
        singleSelection: false,
        items: [
            {
                name: "Side Out",
                selected: true,
                amount: 0
            },
            {
                name: "Transition",
                selected: true,
                amount: 0
            },
        ],
    },
    {
        title: "Display",
        allselected: false,
        singleSelection: true,
        items: [
            {
                name: "Ball Path",
                selected: true,
                amount: 0
            },
            {
                name: "Cone",
                selected: false,
                amount: 0
            },
        ],
    },
    {
        title: "Setters",
        allselected: true,
        singleSelection: false,
    },
    {
        title: "Attackers",
        allselected: true,
        singleSelection: false,
    },
    {
        title: "Results",
        allselected: true,
        singleSelection: false,
        items: [
            {
                name: "Errors",
                selected: true,
                amount: 0
            },
            {
                name: "In-play",
                selected: true,
                amount: 0
            },
            {
                name: "Kill",
                selected: true,
                amount: 0
            },
        ],
    },
    {
        title: "Source",
        allselected: true,
        singleSelection: false,
        items: [
            {
                name: "Front",
                selected: true,
                amount: 0
            },
            {
                name: "Back",
                selected: true,
                amount: 0
            },
            {
                name: "Centre",
                selected: true,
                amount: 0
            },
        ],
    },
    {
        title: "Cones",
        allselected: true,
        singleSelection: false,
        items: [
            {
                name: "1",
                selected: true,
                amount: 0
            },
            {
                name: "2",
                selected: true,
                amount: 0
            },
            {
                name: "3",
                selected: true,
                amount: 0
            },
            {
                name: "4",
                selected: true,
                amount: 0
            },
            {
                name: "5",
                selected: true,
                amount: 0
            },
            {
                name: "6",
                selected: true,
                amount: 0
            },
            {
                name: "7",
                selected: true,
                amount: 0
            },
            {
                name: "8",
                selected: true,
                amount: 0
            },
        ],
    },
];